import KnowEverythingDsfr from "components/templates/knowEverythingDsfr/KnowEverythingDsfr";
import elementsTypes from "utils/elementsTypes";

export default {
  key: "KNOW_EVERYTHING_DSFR",
  label: "Tout savoir (DSFR)",
  Component: KnowEverythingDsfr,
  initialContents: [
    {
      key: "articlesTitle",
      type: elementsTypes.EDITABLE_INPUT,
      value: "Articles",
    },
    {
      key: "highlighted",
      type: elementsTypes.DSFR_CARDS_LIST,
      value: "",
      children: [
        {
          key: "limit",
          value: "1",
        },
        { key: "buttonElementText", value: "un article à la une" },
      ],
    },
    {
      key: "articles",
      type: elementsTypes.DSFR_CARDS_LIST,
      value: "",
      children: [
        {
          key: "limit",
          value: "6",
        },
      ],
    },
    {
      key: "dynamicPart",
      type: "DYNAMIC",
      value: "",
      children: [],
    },
  ],
};
